import React, { Component } from "react";
import { apiUrl } from "../../../comps/apiUrl";
import { toast } from "react-toastify";

import {
  AddIcCallOutlined,
  Delete,
  Edit,
  EditOutlined,
  PersonPinCircleOutlined,
  Print,
  Save,
  UsbRounded,
  WhatsApp,
  WhatshotSharp,
  user,
} from "@mui/icons-material";
import EditNoteIcon from '@mui/icons-material/EditNote';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import {
  faAngleLeft,
  faFile,
  faFileAlt,
  faPen,
  faPrint,
  faSave,
  fawhatsapp,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import alert from "../../../img/alert.svg";
import logomarca from "../../../img/logomarca.jpg";
import withLocation from "../../../comps/withLocation";
import { StaticDialog } from "react-st-modal";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import {
  List,
  ListItemText,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  MenuItem,
  Avatar,
  AvatarGroup,
} from "@mui/material";
import Assinatura from "../../../comps/Assinatura";
class LeaserContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assinar: false,
      assinatura: undefined,
      openDialog: false,
      loaderAss: false,
      checkAss: {},
      error: false,
      loader: true,
      data: [],
      store: {},
      client: {},
      location: {},
      products: {},
      edit: {},
      assType: false,
      assinatura: false,
      share: {}
    };
    this.page = React.createRef();
  }

  componentDidMount() {
    document.title = "Visualizar locação";
    fetch(`${apiUrl}/lease/contract/${this.props.params.token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.setState({
            loader: false,
            error: true,
          });
        }
        this.setState({
          data: data,
          store: data.store,
          client: data.client,
          location: data.location,
          products: data.products,
          contract: data.contract,
          loader: false,
        });
      })
      .catch((error) => {
        toast.error("Ocorreu um erro ao carregar as maquinas");
      });
  }
  dateName(dataString) {
    const data = new Date(dataString);
    const opcoes = { day: "numeric", month: "long", year: "numeric" };
    return new Intl.DateTimeFormat("pt-BR", opcoes).format(data);
  }

  formatarDataBR(dataISO) {
    // Converte a string ISO em um objeto Date
    const data = new Date(dataISO);

    // Extrai as partes da data
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // Meses começam do zero
    const ano = data.getFullYear();

    // Extrai as partes do horário
    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");
    const seconds = String(data.getSeconds()).padStart(2, "0");

    // Retorna no formato brasileiro
    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${seconds}`;
  }

  formatDate(dateString) {
    var e = dateString.split("-");
    var dateString = e[2] + "/" + e[1] + "/" + e[0];
    return dateString;
  }

  render() {
    if (this.state.loader) {
      return (
        <div class="area-loader">
          <div class="loader"></div>
        </div>
      );
    }

    if (this.state.error) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "80vh",
          }}
        >
          <img
            src={alert}
            style={{ width: "400px", top: 100 }}
            alt="imagem de alerta"
          />
          <div>
            Ops! O documento que você está procurando não foi encontrado.
          </div>
        </div>
      );
    }
    var data = this.state.data;
    var typeBiling = data.location.billing;
    var store = this.state.store;
    var client = this.state.client;
    var location = this.state.location;
    var products = this.state.products;
    var invoicingType = {
      1: "Diária",
      2: "Semanal",
      3: "Quizenal",
      4: "Mensal",
      5: "Anual",
    };
    var priceType = {
      1: "day_price",
      2: "weekly_price",
      3: "biweekly_price",
      4: "monthly_price",
      5: "annual_price",
    };

    return (
      <div class="content d-flex justify-content-center">
        <div class="col-8 mt-5">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <Link
                to="/lease-history"
                style={{
                  textDecoration: "none",
                  color: "#5b5b5b",
                  fontSize: 18,
                }}
              >
                <strong>
                  <FontAwesomeIcon icon={faAngleLeft} /> Voltar
                </strong>
              </Link>
              <div style={{ display: "flex", gap: 10 }}>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<WhatsApp />}
                  onClick={(e) => {
                    if (
                      this.state.client.celular == null ||
                      this.state.client.celular == ""
                    ) {
                      toast.error(
                        "O cliente precisa ter um celular cadastrado para enviar o contrato por WhatsApp"
                      );
                      return;
                    }

                    e.target.classList.add("load");

                    fetch(`${apiUrl}/send-pdf-whatsapp`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        token: this.props.params.token,
                        client_id: this.state.client.id,
                        celular: this.state.client.celular.replace(/\D/g, ""),
                      }),
                    })
                      .then((response) => response.json())
                      .then((data) => {
                        e.target.classList.remove("load");
                        if (data.error) {
                          this.setState({ error: data.error });
                        } else {
                          toast.success("Contrato enviado com sucesso");
                          this.setState({ success: data.success });
                        }
                      });
                  }}
                >
                  Enviar Contrato PDF
                </Button>

                <Button component={Link} to="assinaturas" variant="contained" startIcon={<EditNoteIcon />} color="warning">
                  Assinaturas
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    // 1. Cor de fundo do botão (Preto)
                    backgroundColor: "black",

                    // 2. Cor do texto do botão (Branco) para contraste
                    color: "white",

                    // 3. Estilos adicionais para o efeito hover (opcional, mas recomendado)
                    "&:hover": {
                      backgroundColor: "#333333", // Um tom de preto um pouco mais claro no hover
                    },
                  }}
                  startIcon={<Print />}
                  onClick={() => {
                    function Popup(data, style) {
                      var mywindow = window.open("", ".documentoViewToPrint");
                      mywindow.document.write("<html><head><title></title>");
                      /* stylesheet*/
                      mywindow.document.write("<style>" + style + "</style>");
                      mywindow.document.write("</head><body >");
                      mywindow.document.write(data);
                      mywindow.document.write("</body></html>");

                      mywindow.document.close(); // necessary for IE >= 10
                      mywindow.focus(); // necessary for IE >= 10

                      setTimeout(function () {
                        mywindow.print();
                        mywindow.close();
                      }, 100); //1 segundo

                      return true;
                    }

                    //var style = 'table{width:100%}.table, .table td{width:100%;border:1px solid #ccc;border-spacing: 0;border-collapse: collapse;padding:5px;}\n\
                    //                ';

                    var style =
                      ".bold{text-weight:bold}\n\
                              body{\n\
                                  font-size:10px; \n\
                              }\n\
                              .table-bordered, .table-bordered td { \n\
                                  border: 1px solid #ddd;\n\
                                }\n\
                                  .table-bordered, .table-bordered td { \n\
                                  border: 1px solid #ddd;\n\
                                }\n\
                                .table {\n\
                                  width: 100%;\n\
                                  max-width: 100%;\n\
                                  margin-bottom: 20px;\n\
                                  }\n\
                                table{ \n\
                                  border-spacing: 0;\n\
                                  border-collapse: collapse;\n\
                                  }\n\
                                  table td{\n\
                                  font-size:10px;\n\
                                  padding:2px;\n\
                                  }\n\
                                .txtcenter{text-align:center}  \n\
                                .noborder, .noborder td{border:0}\n\
                                .noborderOut{border:0}\n\
                              body{font-size:11px;color:#000;font-family:arial,sans-serif}\n\
                              .txtright{text-align:right} \n\
                              \n\
                              .fontsize20{font-size:20px;}\n\
                              .fontsize16{font-size:16px;}\n\
                              ";

                    Popup(this.page.current.innerHTML, style);
                  }}
                >
                  Imprimir contrato
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Edit />}
                  onClick={() => {
                    this.setState({ edit: this.state.location });
                  }}
                >
                  Editar
                </Button>
              </div>
            </div>
            <div class="card-body">
              <div className="documentoViewToPrint" ref={this.page}>
                <div class="table">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td width="50%" class="paddingtop15">
                          <img src={logomarca} height="90px" width="auto" />
                        </td>
                        <td class="txtright fontsize16">
                          <strong>
                            Contrato Número {this.state.data.renew[0].id}{" "}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <strong>Contrato de Locação </strong>
                  <strong>DADOS DO LOCADOR</strong>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <strong>Nome: </strong>
                          {store.name}
                        </td>
                        <td>
                          <strong>CNPJ: </strong>
                          {store.cnpj}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <strong>Endereço: </strong>
                          {store.address}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Bairro: </strong>
                          {store.neighborhood}
                        </td>
                        <td>
                          <strong>Cidade: </strong>
                          {store.city}
                        </td>
                        <td>
                          <strong>UF: </strong>
                          {store.state}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Celular: </strong>
                          {store.mobile}
                        </td>
                        <td>
                          <strong>Fone Comercial: </strong>
                          {store.phone}
                        </td>
                        <td>
                          <strong>Email: </strong>
                          {store.email}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <strong>Funcionário: </strong>
                          {location.seller_name}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <strong>DADOS DO LOCATÁRIO</strong>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Cliente: </strong>
                          {client.nome != null ? client.nome : "Sem Nome"}
                        </td>
                        <td>
                          <strong>RG: </strong>
                          {client.rg !== null ? client.rg : "Sem RG"}
                        </td>

                        <td>
                          <strong>CPF / CNPJ: </strong>
                          {client.cnpj_cpf != null
                            ? client.cnpj_cpf
                            : "Sem CPF / CNPJ"}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <strong>Data de Nascimento:&nbsp;</strong>
                          {client.data_nascimento != null
                            ? this.formatarDataBR(client.data_nascimento).split(
                              " "
                            )[0]
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <strong>Endereço: </strong>
                          {client.endereco != null
                            ? client.endereco
                            : "Sem Endereço"}{" "}
                        </td>
                        <td>
                          <strong>Número:</strong>
                          {client.numero}
                        </td>
                        <td>
                          <strong>Complemento: </strong>
                          {client.complemento}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Bairro: </strong>
                          {client.bairro != null ? client.bairro : "Sem Bairro"}
                        </td>
                        <td>
                          <strong>Cidade: </strong>
                          {client.cidade != null ? client.cidade : "Sem Cidade"}
                        </td>
                        <td>
                          <strong>UF: </strong>
                          {client.uf != null ? client.uf : "Sem UF"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Celular/Whatsapp: </strong>
                          {client.celular || "Não Informado"}
                        </td>
                        <td>
                          <strong>Telefone: </strong>
                          {client.telefone || "Não Informado"}
                        </td>
                        <td>
                          <strong>Email: </strong>
                          {client.email || "Não Informado"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <strong>PERÍODO DE LOCAÇÃO</strong>
                  <table class="table table-bordered tbl-c mt-3 mb-3">
                    <tbody>
                      {this.state.data.renew.map((item, index) => (
                        <>
                          {index == this.state.data.renew.length - 1 && (
                            <>
                              <tr>
                                <td>
                                  <strong>
                                    {" "}
                                    {item.tdo == 1 ? "Locação" : "Renovação"}
                                    {": "}
                                  </strong>
                                  <strong>
                                    {this.formatarDataBR(item.start_day)}
                                  </strong>{" "}
                                </td>
                                <td>
                                  <strong>Até: </strong>
                                  <strong>
                                    {this.formatarDataBR(item.end_day)}
                                  </strong>{" "}
                                </td>

                                <td>
                                  <strong>Faturamento: </strong>
                                  <strong>
                                    {invoicingType[item.billing]}
                                  </strong>{" "}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="8" className="txtcenter">
                                  <strong>OBJETO DA LOCAÇÃO</strong>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Nº.</strong>
                                </td>
                                <td>
                                  <strong>Qtde.</strong>
                                </td>

                                <td>
                                  <strong>Descrição</strong>
                                </td>
                                <td>
                                  <strong>
                                    Caracteristicas do Equipamento
                                  </strong>
                                </td>
                                <td className="valores">
                                  <strong>Valor por Período</strong>
                                </td>
                                <td className="valores">
                                  <strong>Qtde. Períodos</strong>
                                </td>
                                <td className="valores">
                                  <strong>Valor Total Item</strong>
                                </td>
                              </tr>
                              {item.products.map((product, index) => (
                                <>
                                  {" "}
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{product.quantiny}</td>

                                    <td>{product.name}</td>
                                    <td>



                                      {product.itens_selected.length > 0 ? (
                                        <>
                                          {product.itens_selected.map(
                                            (item, index) => (
                                              <a
                                                href={`/equipamentos/vinculo/${item.ref}`}
                                                target="_blank"
                                              >
                                                {item.cat}.{item.sub}.{item.idu}
                                              </a>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        "---"
                                      )}
                                    </td>
                                    <td>
                                      {typeBiling > 5
                                        ? "R$ 0,00"
                                        : product[
                                          priceType[typeBiling]
                                        ].toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })}
                                    </td>
                                    <td>{location.rental_period}</td>
                                    <td>
                                      {(
                                        location.rental_period *
                                        product[priceType[typeBiling]]
                                      ).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      })}
                                    </td>
                                  </tr>
                                </>
                              ))}
                              <tr>
                                <td colSpan="5">
                                  <strong>
                                    Valor da Multa por Dia de Atraso:
                                  </strong>
                                </td>
                                <td colSpan="3" className="valores">
                                  {item.fine == null
                                    ? "R$ 0,00"
                                    : item.fine.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="5">
                                  <strong>Valor do Frete:</strong>
                                </td>
                                <td colSpan="3" className="valores">
                                  {item.shipping_cost == null
                                    ? "R$ 0,00"
                                    : item.shipping_cost.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="5">
                                  <strong>Valor Total:</strong>
                                </td>
                                <td colSpan="3" className="valores">
                                  {item.location_value == null
                                    ? "R$ 0,00"
                                    : (
                                      item.location_value +
                                      (item.shipping_cost || 0)
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                </td>
                              </tr>
                              <br />
                            </>
                          )}
                        </>
                      ))}
                    </tbody>
                  </table>

                  <strong>OBSERVAÇÃO:</strong>
                  {this.state.location.obs}
                  <br />
                  <br />
                  <div class="divClausulasContratuais">
                    <div
                      dangerouslySetInnerHTML={{ __html: this.state.contract }}
                    />
                  </div>
                  <div
                    style={{
                      margin: "0 auto",
                      wordBreak: "break-word",
                      width: "100%",
                      maxWidth: "600px",
                    }}
                  >
                    <div class="folha">
                      <br />
                      <br />
                      <br />
                      {store.city},{" "}
                      {this.dateName(this.state.data.renew[0].start_day)}
                      <br />
                      <br />
                      <br />
                      <div>
                        <img src={`${apiUrl}/assinatura`} />
                        <hr />
                      </div>{" "}
                      <br />
                      Locador
                      <br />
                      {store.name} <br />
                      CNPJ: {store.cnpj}
                      <br />
                      <br />

                      <br />
                      Locatário
                      <br />
                      {client.nome}
                      <br />
                      CPF/CNPJ: {client.cnpj_cpf}
                    </div>


                  </div>
                  { }
                </div>
              </div>
            </div>
            {data.telefone_celular != undefined && (
              <>
                <div className="card-footer d-flex justify-content-end">
                  <button
                    className="btn b-wpp"
                    onClick={(e) => {
                      e.target.classList.add("load");
                      fetch(
                        `${apiUrl}/send-budget/${window.location.pathname.split("/")[3]
                        }`,
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            authorization: localStorage.getItem("token"),
                          },
                          body: JSON.stringify({}),
                        }
                      )
                        .then((response) => {
                          e.target.classList.remove("load");
                          toast.success("Orçamento enviado com sucesso");
                        })
                        .catch((error) => {
                          e.target.classList.remove("load");
                          toast.error("Ocorreu um erro ao enviar o orcamento");
                        });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#fff"
                      viewBox="0 0 448 512"
                    >
                      <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
                    </svg>
                    Enviar orçamento
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        <StaticDialog
          isOpen={Object.keys(this.state.checkAss).length > 0}
          title="Assinatura do Cliente1"
          onAfterClose={(result) => {
            this.setState({
              checkAss: false,
            });
          }}
        ></StaticDialog>

        <StaticDialog
          isOpen={this.state.sendWpp}
          title="Assinatura do Cliente"
          onAfterClose={(result) => {
            this.setState({
              sendWpp: false,
            });
          }}
        >
          <div className="modal-body" style={{ margin: "10px" }}></div>
        </StaticDialog>

        <StaticDialog
          isOpen={Object.keys(this.state.edit).length > 0}
          title="Editar"
          onAfterClose={(result) => {
            this.setState({
              edit: {},
            });
          }}
        >
          <div className="modal-body" style={{ margin: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Observação"
              variant="outlined"
              style={{ width: "100%" }}
              value={this.state.edit.obs || ""}
              onChange={(e) => {
                this.setState(({ edit }) => ({
                  edit: { ...edit, obs: e.target.value },
                }));
              }}
            />
          </div>

          <div
            style={{
              margin: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={(e) => {
                var { obs } = this.state.edit;
                e.target.classList.add("load");
                fetch(
                  `${apiUrl}/lease/contract/edit/${this.props.params.token}`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      authorization: localStorage.getItem("token"),
                    },
                    body: JSON.stringify({
                      obs: obs,
                    }),
                  }
                )
                  .then((response) => response.json())
                  .then((data) => {
                    toast.success("Observação salva com sucesso");
                    this.setState(({ location }) => ({
                      location: { ...location, obs },
                      edit: {},
                    }));
                  });
              }}
            >
              <FontAwesomeIcon icon={faSave} /> Salvar
            </button>
          </div>
        </StaticDialog>

        <Dialog
          onClose={() => {
            this.setState({
              assType: false,
            });
          }}
          open={this.state.assType}
        >
          <DialogTitle>Selecione a opção</DialogTitle>

          <List sx={{ pt: 0 }}>
            {/* Assinar agora */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  fetch(
                    `${apiUrl}/obter/assitura/${window.location.pathname
                      .split("/")
                      .pop()}`,
                    {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                        authorization: localStorage.getItem("token"),
                      },
                    }
                  ).then((response) => {
                    response.json().then((data) => {
                      this.setState({
                        assType: false,
                        assinar: true,
                      });
                    });
                  });
                }}
              >
                <ListItemAvatar>
                  <Avatar>
                    <EditOutlined />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Assinar agora" />
              </ListItemButton>
            </ListItem>

            {/* Enviar por WhatsApp */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  fetch(`${apiUrl}/send/assinatura/`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      authorization: localStorage.getItem("token"),
                    },
                    body: JSON.stringify({
                      contract: window.location.pathname.split("/").pop(),
                      client: this.state.client.id,
                    }),
                  })
                    .then((response) => {
                      if (response.status == 401) {
                        toast.warn("Pedido já enviado");
                        return;
                      }
                      if (response.status == 403) {
                        toast.warn("O Cliente Não Tem WhatsApp Cadastrado No Sistema");
                        return;
                      }
                      if (response.status == 200) {
                        this.setState({
                          assType: false,
                        });
                        toast.success("Assinatura enviada com sucesso");
                      }
                    })
                    .catch((error) => {
                      toast.error("Ocorreu um erro ao enviar a assinatura");
                    });
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "#25D366" }}>
                    <WhatsApp />
                  </Avatar>
                </ListItemAvatar>

                <ListItemText primary="Enviar por WhatsApp" />
              </ListItemButton>
            </ListItem>


            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  fetch(
                    `${apiUrl}/obter/assitura/${window.location.pathname
                      .split("/")
                      .pop()}`,
                    {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                        authorization: localStorage.getItem("token"),
                      },
                    }
                  ).then((response) => {
                    response.json().then((data) => {
                      this.setState({ share: data })
                    });
                  });
                }}
              >
                <ListItemAvatar>
                  <Avatar>
                    <EditOutlined />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Copiar Link" />
              </ListItemButton>
            </ListItem>


          </List>
        </Dialog>



        <Dialog
          onClose={() => {
            this.setState({ share: {} });
          }}
          maxWidth="xs" // "xs" costuma ficar mais elegante para compartilhamento
          fullWidth
          open={Object.keys(this.state.share).length > 0}
        >
          <DialogTitle style={{ fontWeight: 'bold', textAlign: 'center' }}>
            Compartilhar Link
          </DialogTitle>

          <DialogContent dividers>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={3}
              my={2}
            >
              {/* Área do QR Code bem centralizada e com borda suave */}
              {this.state.share.QrCode && (
                <Box
                  component="img"
                  src={this.state.share.QrCode}
                  alt="QR Code"
                  sx={{
                    width: 180,
                    height: 180,
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    p: 1,
                    boxShadow: '0px 4px 10px rgba(0,0,0,0.05)'
                  }}
                />
              )}

              <Typography variant="body2" color="textSecondary" textAlign="center">
                Escaneie o QR Code acima assinar digitalmente o contrato
              </Typography>

              {/* Campo de texto estruturado */}
              <TextField
                label="Link do Contrato"
                fullWidth
                variant="outlined"
                readOnly
                value={`https://painel.rbhidraulicos.com.br/assinar/contrato/${this.state.share.ref}`}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Box>
          </DialogContent>

          <DialogActions sx={{ justifyContent: 'space-between', px: 3, py: 2 }}>
            <Button
              onClick={() => this.setState({ share: {} })}
              color="inherit"
            >
              Fechar
            </Button>

            <Button
              variant="contained"
              color="primary"
              startIcon={<ContentCopyIcon />}
              onClick={() => {
                const url = `https://painel.rbhidraulicos.com.br/assinar/contrato/${this.state.share.ref}`;
                navigator.clipboard.writeText(url)
                  .then(() => {
                    alert('Link copiado para a área de transferência!'); // Você pode substituir por um SnackBar depois
                  })
                  .catch((err) => {
                    console.error('Erro ao copiar link: ', err);
                  });
              }}
            >
              Copiar Link
            </Button>
          </DialogActions>
        </Dialog>


      </div>
    );
  }
}

export default withLocation(LeaserContract);
